export const pluralizeAdminTabLabel = (label?: string | null) => {
  const trimmed = String(label || '').trim();
  if (!trimmed) {
    return '';
  }

  if (trimmed === 'Direction' || trimmed === 'Résultats des tests') {
    return trimmed;
  }

  if (trimmed === 'Bénéficiaire') {
    return 'Bénéficiaires';
  }

  if (trimmed === 'Consultant') {
    return 'Consultants';
  }

  if (trimmed.startsWith('Responsable ')) {
    return `Responsables ${trimmed.slice('Responsable '.length)}`;
  }

  return trimmed;
};
